<div class="col-12 h-full">
  <p-divider align="center">
    <span class="p-tag">{{libTrace}}</span>
    <i class="icons8 iconize cursorPointer "
      pTooltip="{{'Trace_Move' | translate}}"
      (click)="swithTrace()"
      >&#xf10f;
    </i>
  </p-divider>
  @if (skeleton === true) {    
    @if (error === true) {
      <div class="text-center font-bold text-lg" style="color: red;">{{'Load_Data_KO' | translate}}</div>    
    }@else {      
      <p-skeleton width="100%" height="100%"/>
    }
  }@else {
    <div class="p-fluid">
      <div class="grid">
        @for (item of traces; track item; let i = $index) {
          <div class="col-3 event-time">{{ item.Date | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
          <div class="col-1">
            @switch (item.Type) {
              @case (13000) {
                <i class="pi pi-plus md-18" style="color: green"></i>
              }
              @case (13001) {
                <i class="pi pi-replay md-18" style="color: orange"></i>
              }
              @case (13002) {
                <i class="pi pi-download md-18" style="color: orange"></i>
              }
              @case (13003) {
                <i class="pi pi-download md-18" style="color: lightgreen"></i>
              }
              @case (13004) {
                <i class="pi pi-comment md-18" style="color: cyan"></i>
              }
              @case (13005) {
                <i class="pi pi-comment md-18" style="color: cyan"></i>
              }
              @case (13006) {
                <i class="pi pi-tag md-18" style="color: cyan"></i>
              }
              @case (13007) {
                <i class="pi pi-tag md-18" style="color: cyan"></i>
              }
              @case (13008) {
                <i class="pi pi-tag md-18" style="color: cyan"></i>
              }
              @case ('Info') {
                <i class="pi pi-info-circle md-18" style="color: green"></i>
              }
              @case ('Error') {
                <i class="pi pi-exclamation-circle md-18" style="color: red"></i>
              }
              @case (13009) {
                <i class="pi pi-pencil md-18" style="color: green"></i>
              }
              @case (13010) {
                <i class="pi pi-pencil md-18" style="color: green"></i>
              }
              @case (13011) {
                <i class="pi pi-pencil md-18" style="color: green"></i>
              }
              @case (13012) {
                <i class="pi pi-cog md-18" style="color: green"></i>
              }
              @case (13013) {
                <i class="pi pi-lock md-18" style="color: red"></i>
              }
              @case (13014) {
                <i class="pi pi-lock-open md-18" style="color: green"></i>
              }
              @case (13015) {
                <i class="pi pi-inbox md-18" style="color: green"></i>
              }
              @case (13016) {
                <i class="pi pi-inbox md-18" style="color: green"></i>
              }
              @case (13017) {
                <i class="pi pi-inbox md-18" style="color: green"></i>
              }
              @case (13018) {
                <i class="pi pi-envelope md-18" style="color: green"></i>
              }
              @case (13019) {
                <i class="pi pi-trash md-18" style="color: red"></i>
              }
              @case (13020) {
                <i class="pi pi-arrow-right md-18" style="color: orange"></i>
              }
              @case (13021) {
                <i class="pi pi-times md-18" style="color: orange"></i>
              }
              @case (13023) {
                <i class="pi pi-clone md-18" style="color: cyan"></i>
              }
              @case (13024) {
                <i class="pi pi-clone md-18" style="color: cyan"></i>
              }
              @case (13025) {
                <i class="pi pi-clone md-18" style="color: cyan"></i>
              }
              @default {
                <i class="pi pi-ellipsis-h md-18" style="color: blue"></i>
              }
            }
          </div>
          <div class="col-8">
            <span class="event-owner margin" style="color: black; font-weight: bold">{{ item.User }}</span>
            <span style="display: inline" class="event-text">{{ item.Value }}</span>
          </div>
        }
      </div>
    </div>
  }
</div>
